import React from 'react';
import { css } from 'styled-components';

import Button from '../../../common/components/basic/Button';
import styles from '../../../common/utils/styles/css/styles';
import GoogleLogo from '../../../common/components/assets/GoogleLogo';
import firebase from '../../../common/firebase';

import { K_AMPLITUDE_EVENT_CLICK_LOGIN_VIA_GMAIL } from '../../../common/libs/amplitude/events';
import { useTranslation } from 'react-i18next';
import useTracking from '../../../common/utils/tracking/useTracking';

export default function GmailLoginButton() {
  const tracking = useTracking();
  const { t } = useTranslation();

  function handleLoginViaGmail() {
    const provider = new firebase.auth.GoogleAuthProvider();
    tracking.logEvent(K_AMPLITUDE_EVENT_CLICK_LOGIN_VIA_GMAIL);
    return firebase.auth().signInWithPopup(provider);
  }
  return (
    <Button type="light" css={[styles.flexMiddle]} onClick={handleLoginViaGmail}>
      <GoogleLogo
        css={css`
          margin-top: -3px;
          margin-right: 4px;
        `}
      />
      {t('signin.login_with_google', 'Login With Google')}
    </Button>
  );
}
